import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import {
  APIHireDubaiIcon,
  SmoothHireDubaiIcon,
  CRMHireDubaiIcon,
  RegularHireDubaiIcon,
} from "../../../app-constants";

function Facilitatehiring() {
  return (
    <div className="facilitate_hiring p-100">
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={6} xxl={6} className="resp_order">
            <Row>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
                <div className="faclitate_box">
                  <div className="facilitate_img">{APIHireDubaiIcon}</div>
                  <div className="facilitate_content">
                    <h6>Experienced Resources</h6>
                    <p>
                      We ensure to assign well-qualified resources to each
                      project with proven experience in the relevant type of
                      project.
                    </p>
                  </div>
                </div>
                <div className="faclitate_box">
                  <div className="facilitate_img">{SmoothHireDubaiIcon}</div>
                  <div className="facilitate_content">
                    <h6>Clear Communication</h6>
                    <p>
                      Our team ensures to conduct every phase of the project
                      with honest communication to maintain the transparency of
                      the whole process.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
                <div className="faclitate_box mt_top">
                  <div className="facilitate_img">{CRMHireDubaiIcon}</div>
                  <div className="facilitate_content">
                    <h6>Customized Solutions</h6>
                    <p>
                      You can hire app developers in KSA from us who are experts
                      in fluffing the specified requirements of your project
                      with efficient customization.
                    </p>
                  </div>
                </div>
                <div className="faclitate_box">
                  <div className="facilitate_img">{RegularHireDubaiIcon}</div>
                  <div className="facilitate_content">
                    <h6>Dedicated Support</h6>
                    <p>
                      Our support is always available even after the completion
                      of the project as we believe in the proper updates of apps
                      as per the latest trends.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 my-auto "
          >
            <h2>
              How We Can Assist You With the Best Mobile App Developers for
              Hire?
            </h2>
            <p>
              Efficiently hire skilled app developers for your projects,
              ensuring a seamless match for your next project.
            </p>
            <strong>
              Slash Development Costs by Over <span>70%!</span>
            </strong>
            <strong>
              Hire Top Developers with Us for Maximum Efficiency and Value
            </strong>
            <div className="faclitate_btn">
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Hire A Developer Now!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Facilitatehiring;
